import Vue from 'vue';
import BonusesPage from '@/components/pages/bonus/index.vue';
export default Vue.extend({
    name: 'BonusesView',
    components: {
        BonusesPage
    }
});
